import React, { useState, useEffect, useContext } from 'react';
import { createElement } from 'react';

import AnswerInput from "./AnswerInput";
import AnswerBtns from './AnswerBtns'

type QuestRes = {
    Answers: string
    QName: string
    QSNo: number
    defAns?: string
    ItemID?: string
    ItemTxt?: string
    QType: number
}

type QProps = {
    quests:QuestRes[]
    cardData:CardProps
    ansList:ResAnswers[]
    isComplete:(complete:boolean)=>void
}

const detectURL = (str: string) => {
    const pattern = new RegExp('(https?:\/\/)?([\da-z\.-]+)\.([a-z1-9\.]{2,100})([\/\w \.-]*)*\/?', 'i');
    const res: RegExpMatchArray = str.match(pattern) as RegExpMatchArray
    if (res) {
        //console.log(str.split("，"))

        return createElement(
            'span',
            null,
            str.split(res[0])[0],
            createElement('a', {href:res[0], target:"_blank"}, res[0]),
            (str.split(res[0])[1]?str.split(res[0])[1]:null)
        );
        //return str.replace(res[0], `<a href='${res[0]}'>${res[0]}</a>`)
    } else {
        return str
    }


    //return !!pattern.test(str);
}



export default (props:QProps) => {

    const [quests] = useState(props.quests)
    const [notDone, setNotDone] = useState<boolean>(true)
    const [ansList, setAnsList] = useState<ResAnswers[]>(props.ansList)

    useEffect(()=>{
        return
    },[])
    
    useEffect(()=>{
        setAnsList(props.ansList)
        checkAnsTotal()
    },[props.ansList, quests])
    

    const checkAnsTotal = () => {
        //let count: number = 0
        let countAry: string[] = []
        props.ansList.map((item) => {
            if (item.ItemID) {
                countAry.push(item.ItemID)
            } else if (item.ItemTxt) {
                countAry.push(item.ItemTxt)
            }
    
        })


        if (quests.length == countAry.length) {
            setNotDone(false)
            props.isComplete(false);
        } else {
            setNotDone(true)
            props.isComplete(true);
        }
    }
    return (
        <div >
            <div className="secTitle">問卷調查</div>
            {
                quests.map((quest: QuestRes, index: number) => {
                    return (
                        <div key={"question-" + index}>
                            <div className="title">
                                <span>
                                    {index + 1}.
                                </span>
                                <span>

                                 {detectURL(quest.QName)}
                                </span>
                            </div>
                            <div>
                                {
                                    quest.QType == 3 ?
                                        <AnswerInput
                                            qName={quest.QName}
                                            isAnswered={
                                                (
                                                    [1, 7].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                    props.cardData?.editable == 0
                                                ) == true
                                            }
                                            defAns={ansList[index]?.ItemTxt}
                                            serial={index}
                                            QSNo={quest.QSNo}
                                            checker={checkAnsTotal}
                                        //jsonString={quest.Answers}
                                        /> :
                                        <AnswerBtns
                                            qName={quest.QName}
                                            defAns={ansList[index]?.ItemID}
                                            showAns={
                                                (
                                                    [1, 7].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                    props.cardData?.editable == 0
                                                ) == true
                                            }
                                            serial={index}
                                            QSNo={quest.QSNo}
                                            jsonString={quest.Answers}
                                            checker={checkAnsTotal}
                                        />
                                }
                            </div>
                        </div>
                    )

                })
            }
            {
                notDone &&
                <p style={{ color: "#f30" }}>填寫或修改全部的問卷內容即可送出</p>
            }
            
        </div>
    )
}

